<template>
  <div class="side-menu">

    <nav class="navbar-default navbar-static-side" role="navigation" :class="{collapsed: collapsed, 'animated fadeInLeft': isMobile()}">
      <div class="sidebar-collapse">
        <ul class="nav">

          <li class="nav-header">
            <img @click="closeIfMobile(); goAccount();" data-toggle="tooltip" title="Minha Conta" alt="image" class="img-circle" :src="user.img || '/static/img/profile.jpg'" />
            <a @click="closeIfMobile(); goAccount();" v-show="!collapsed" data-toggle="dropdown" class="dropdown-toggle" title="Minha Conta">
              <span class="m-t-xs"> <strong>{{ user.name }}</strong></span>
            </a>
            <button @click.prevent="closeIfMobile()" class="btn btn-link visible-xs-block"><i class="fa fa-close"/></button>
          </li>

          <li class="nav-menu" v-for="menu in menuOptions" v-bind:key="menu.name">
            <router-link :to="menu.path" @click.native="closeIfMobile()" data-toggle="tooltip" v-bind:title="menu.name"> <i :class="menu.icon"></i>
              <span v-show="!collapsed" class="nav-label"> {{ menu.name }} </span> <span v-show="!collapsed" class="fa arrow"></span>
            </router-link>
          </li>

        </ul>

      </div>
    </nav>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        expires: new Date(),
        menuOptions: [
          { name: 'Página Principal',icon: 'fa fa-home', path: '/home' },
          { name: 'Usuários', icon: 'fa fa-users', path: '/users' },
          { name: 'Clientes', icon: 'fa fa-building', path: '/company' },
          // { name: 'Notificações', icon: 'fa fa-bell', path: '/notifications' },
          //{ name: 'Página Branca', icon: 'fa fa-file-o', path: '/blank-page' },
        ]
      }
    },
    methods: {
      closeIfMobile() {
        if(this.isMobile()) {
          this.$store.state.collapsed = true
          const page = $('#page-wrapper').addClass('collapse-animation').removeClass('expand-animation')
          setTimeout(() => { page.toggleClass('collapsed') }, 100)
        }
      },
      isMobile() {
        return window.innerWidth < 768
      },
      goAccount() { this.$router.push('/account') }
    },
    filters: {
      capitalize: (value) => {
        if(!value) { return }
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
    },
    computed: {
      user() { return this.$store.getters.getLoggedUser },
      collapsed() { return this.$store.state.collapsed }
    }
  }
</script>

<style scoped>
  .img-circle {
    width: 60px;
    min-height: 60px;
    margin: 3px;
    padding: 3px;
    cursor: pointer;
  }

  .img-circle img {
    max-width: 100%;
    height: auto;
  }

  .nav-header {
    text-align: center;
    padding: 10px;
  }

  .dropdown-toggle { padding: 0; }

  @media (max-width: 767px) {
    .navbar-default, .sidebar-collapse, ul.nav {
      position:fixed;
      width: 100%;
      height: 100%;
      z-index: 9999;
      background-color: #2f4050;
    }
    .nav-header { background-repeat: repeat; }
    .nav-header button.btn-link {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      margin-right: 20px;
      font-size: 25px;
      color: #DFE4ED;
    }
    .navbar-default.collapsed { display: none; }
  }

  @media (min-width: 768px) {
    .collapsed .img-circle {
      width: 34px;
      min-height: 34px;
    }
    .collapsed .nav-header {
      width: 50px;
      height: 50px;
      padding: 5px;
    }
    .collapsed .nav-menu a{
      width: 50px;
      padding: 14px 20px 14px 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/SideMenu.vue